// extracted by css-extract-rspack-plugin
export default {"fileRendererViewport":"RichDiff-module__fileRendererViewport__wcmGL","fileRendererIframe":"RichDiff-module__fileRendererIframe__w06bk"};